module.exports = __webpack_public_path__ + "78008db873d50fc87e245b1a23de9e05.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fontello/fontello.eot?67495670
// module id = 1017
// module chunks = 0